import axios from 'axios';
import { getValidToken } from './authService';
import { isDemoMode, demoGetCategories, demoGetCategoryById, demoGetCategoryByName, demoAddCategory } from '../demo/demoStore';

const API_URL = process.env.REACT_APP_API_URL;

const apiClient = axios.create({
  baseURL: API_URL,
});

apiClient.interceptors.request.use(async (config) => {
  const token = await getValidToken(); 
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

const addContextParams = (params, contextParams) => {
  return {
    ...params,
    context: contextParams.context,
    ...(contextParams.groupId && { groupId: contextParams.groupId })
  };
};

export const addCategory = async (categoryData, contextParams) => {
  if (isDemoMode()) return demoAddCategory();
  const payload = {
    ...categoryData,
    context_type: contextParams.context,
    group_id: contextParams.groupId || null
  };
  const response = await apiClient.post('/category', payload);
  return response.data;
};

export const getCategories = async (contextParams) => {
  if (isDemoMode()) return demoGetCategories();
  const params = addContextParams({}, contextParams);
  const response = await apiClient.get('/categories', { params });
  return response.data;
};

export const getCategoryById = async (id, contextParams) => {
  if (isDemoMode()) return demoGetCategoryById(id);
  const params = addContextParams({}, contextParams);
  const response = await apiClient.get(`/category/${id}`, { params });
  return response.data;
};

export const deleteCategory = async (id, contextParams) => {
  if (isDemoMode()) return Promise.resolve({ success: true });
  const params = addContextParams({}, contextParams);
  const response = await apiClient.delete(`/category/${id}`, { params });
  return response.data;
};

export const updateCategory = async (id, categoryData, contextParams) => {
  if (isDemoMode()) return Promise.resolve({ success: true });
  const payload = {
    ...categoryData,
    context_type: contextParams.context,
    group_id: contextParams.groupId || null
  };
  const params = addContextParams({}, contextParams);
  const response = await apiClient.put(`/category/${id}`, payload, { params });
  return response.data;
};

export const getCategoryByName = async (name, contextParams) => {
  if (isDemoMode()) return demoGetCategoryByName(name);
  const params = addContextParams({}, contextParams);
  const response = await apiClient.get(`/category/name/${name}`, { params });
  return response.data;
}; 

const DEFAULT_CATEGORIES = [
    { name: 'Salary', type: 'INCOME' },
    { name: 'Freelance', type: 'INCOME' },
    { name: 'Other Incomes', type: 'INCOME' },
    { name: 'Food', type: 'EXPENSE' },
    { name: 'Groceries', type: 'EXPENSE' },
    { name: 'Transportation', type: 'EXPENSE' },
    { name: 'Utilities', type: 'EXPENSE' },
    { name: 'Entertainment', type: 'EXPENSE' },
    { name: 'Shopping', type: 'EXPENSE' },
    { name: 'Travel', type: 'EXPENSE' },
    { name: 'Insurance', type: 'EXPENSE' },
    { name: 'Subscriptions', type: 'EXPENSE' },
    { name: 'Other Expenses', type: 'EXPENSE' },
    { name: 'Stocks', type: 'INVESTMENT' },
    { name: 'Bonds', type: 'INVESTMENT' },
    { name: 'Cryptocurrency', type: 'INVESTMENT' }
  ];

export const createDefaultCategories = async () => {
  try {
    const personalContext = { context: 'personal', groupId: null };
    
    const promises = DEFAULT_CATEGORIES.map(category => 
      addCategory(category, personalContext)
    );
    
    await Promise.allSettled(promises); 
    console.log('Default categories created successfully');
  } catch (error) {
    console.error('Error creating default categories:', error);
  }
};

export const createDefaultCategoriesForGroup = async (groupId) => {
  try {
    const groupContext = { context: 'group', groupId: groupId };
    
    const promises = DEFAULT_CATEGORIES.map(category => 
      addCategory(category, groupContext)
    );
    
    await Promise.allSettled(promises);
    console.log(`Default categories created successfully for group ${groupId}`);
    return true;
  } catch (error) {
    console.error(`Error creating default categories for group ${groupId}:`, error);
    return false;
  }
};